declare let window: any;

export interface WootricData {
  email?: string;
  createdAt?: number;
  accountToken?: string;
  persona?: string;
  success?: string;
  partnerId?: string;
  partnerName?: string;
  userMarket?: string;
}

export function initializeWootric(config: WootricData): void {
  if (config?.email && typeof window !== 'undefined') {
    window.wootricSettings = {
      email: config.email,
      created_at: config.createdAt,
      account_token: config.accountToken,
      properties: {
        persona: 'Partner',
        success: config.success,
        partner_id: config.partnerId,
        partner_name: config.partnerName,
        user_market: config.userMarket,
      },
    };
    if (typeof window !== 'undefined' && Boolean(window.wootric)) {
      window.wootric('run');
    } else {
      console.error(`wootric not loaded`);
    }
  }
}
